<div class="flex w-full max-w-[1200px] mx-auto flex-col md:flex-row gap-[20px] pb-[80px] justify-center items-center">
    <div class="flex flex-col items-start gap-[80px] self-stretch 
            px-6 pt-12 pb-8">

        <!-- Section Title -->
        <div class="flex flex-col items-start gap-4 self-stretch">
            <span
                class="text-[#00B884] text-center font-[Manrope] text-[16px] not-italic font-medium leading-[17px] tracking-[1px] uppercase">
                {{'Why' | translate}}
            </span>
            <h2 class="self-stretch font-[Manrope] text-[45px] not-italic font-bold leading-[58px] tracking-[-0.9px]">
                <span class="text-[#F2305E]"> {{'Why' | translate}} </span>{{'you need Car Insurance?' | translate}}
            </h2>
            <p
                class="self-stretch text-[#1B1B1B] font-[Manrope] text-[20px] not-italic font-normal leading-[140%] tracking-[-0.4px]">
                {{'Insurance keeps you legally protected, saves you from costly repairs, and ensures peace of mind on every journey' |translate}}
            </p>
            <span class="w-[100px] h-[5px] rounded-[5px] bg-[#FD71AF] block"></span>
        </div>

        <!-- Features List -->
        <div class="flex flex-col items-start gap-[32px]">

            <!-- Item 1 -->
            <div class="flex items-center gap-8 self-stretch">
                <div class="flex w-[60px] h-[60px] justify-center items-center rounded-[12.727px] bg-[#EF3A5C]">
                    <img src="/png/financial.png" alt="icon" class="w-[24px] h-[24px]" />
                </div>
        <h3 class="flex-1 text-[#1B1B1B] font-[Manrope] font-normal leading-[140%] text-[20px] max-[900px]:text-[16px]">
            {{'Ensures legal compliance and covers third-party damages in case of an accident'
            | translate}}
        </h3>
            </div>

            <!-- Item 2 -->
            <div class="flex items-center gap-8 self-stretch">
                <div class="flex w-[60px] h-[60px] justify-center items-center rounded-[12.727px] bg-[#EF3A5C]">
                    <img src="/png/Comprehensive.png" alt="icon" class="w-[24px] h-[24px]" />
                </div>
            <h3 class="flex-1 text-[#1B1B1B] font-[Manrope] font-normal leading-[140%] text-[20px] max-[900px]:text-[16px]">
                {{'Protects your car against risks such as collisions, fire, natural disasters, or theft'
                | translate}}
            </h3>
            </div>

            <!-- Item 3 -->
            <div class="flex items-center gap-8 self-stretch">
                <div class="flex w-[60px] h-[60px] justify-center items-center rounded-[12.727px] bg-[#EF3A5C]">
                    <img src="/png/livwell.png" alt="icon" class="w-[24px] h-[24px]" />
                </div>
                <h3 class="flex-1 text-[#1B1B1B] font-[Manrope] font-normal leading-[140%] text-[20px] max-[900px]:text-[16px]">
                    {{'Provides financial support for the driver and passengers in the event of an accident'
                    | translate}}
                </h3>
            </div>

            <!-- Item 4 -->
            <div class="flex items-center gap-8 self-stretch">
                <div class="flex w-[60px] h-[60px] justify-center items-center rounded-[12.727px] bg-[#EF3A5C]">
                    <img src="/png/financial.png" alt="icon" class="w-[24px] h-[24px]" />
                </div>
                <h3 class="flex-1 text-[#1B1B1B] font-[Manrope] font-normal leading-[140%] text-[20px] max-[900px]:text-[16px]">
                    {{'Includes roadside assistance, flood damage coverage, and other useful supports'
                    | translate}}
                </h3>
            </div>
        </div>
    </div>

<div
  class="flex justify-center items-center mt-0 sm:mt-[91.666px] w-full sm:w-[422px]"
>
  <div
    class="w-full max-w-[400px] aspect-[171/131] 
    bg-[url('/png/whyyouneed.png')] bg-no-repeat bg-center bg-cover rounded-xl"
  ></div>
</div>

</div>